export const TilesIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_1506_8850)">
        <rect
          width="102"
          height="102"
          rx="12.5446"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M30.5833 24.75C29.0362 24.75 27.5525 25.3646 26.4585 26.4585C25.3646 27.5525 24.75 29.0362 24.75 30.5833V48.0833C24.75 49.6304 25.3646 51.1142 26.4585 52.2081C27.5525 53.3021 29.0362 53.9167 30.5833 53.9167H48.0833C49.6304 53.9167 51.1142 53.3021 52.2081 52.2081C53.3021 51.1142 53.9167 49.6304 53.9167 48.0833V30.5833C53.9167 29.0362 53.3021 27.5525 52.2081 26.4585C51.1142 25.3646 49.6304 24.75 48.0833 24.75H30.5833ZM62.6667 33.5C61.1196 33.5 59.6358 34.1146 58.5419 35.2085C57.4479 36.3025 56.8333 37.7862 56.8333 39.3333V48.0833C56.8333 49.6304 57.4479 51.1142 58.5419 52.2081C59.6358 53.3021 61.1196 53.9167 62.6667 53.9167H71.4167C72.9638 53.9167 74.4475 53.3021 75.5415 52.2081C76.6354 51.1142 77.25 49.6304 77.25 48.0833V39.3333C77.25 37.7862 76.6354 36.3025 75.5415 35.2085C74.4475 34.1146 72.9638 33.5 71.4167 33.5H62.6667ZM56.8333 62.6667C56.8333 61.1196 57.4479 59.6358 58.5419 58.5419C59.6358 57.4479 61.1196 56.8333 62.6667 56.8333H71.4167C72.9638 56.8333 74.4475 57.4479 75.5415 58.5419C76.6354 59.6358 77.25 61.1196 77.25 62.6667V71.4167C77.25 72.9638 76.6354 74.4475 75.5415 75.5415C74.4475 76.6354 72.9638 77.25 71.4167 77.25H62.6667C61.1196 77.25 59.6358 76.6354 58.5419 75.5415C57.4479 74.4475 56.8333 72.9638 56.8333 71.4167V62.6667ZM36.4167 56.8333C34.8696 56.8333 33.3858 57.4479 32.2919 58.5419C31.1979 59.6358 30.5833 61.1196 30.5833 62.6667V71.4167C30.5833 72.9638 31.1979 74.4475 32.2919 75.5415C33.3858 76.6354 34.8696 77.25 36.4167 77.25H45.1667C46.7138 77.25 48.1975 76.6354 49.2915 75.5415C50.3854 74.4475 51 72.9638 51 71.4167V62.6667C51 61.1196 50.3854 59.6358 49.2915 58.5419C48.1975 57.4479 46.7138 56.8333 45.1667 56.8333H36.4167Z"
          fill="white"
        />
        <rect
          x="0.418153"
          y="0.418153"
          width="101.164"
          height="101.164"
          rx="12.1264"
          stroke="url(#paint0_linear_1506_8850)"
          strokeWidth="0.836306"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_1506_8850"
          x="-21.744"
          y="-21.744"
          width="145.488"
          height="145.488"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10.872" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1506_8850"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1506_8850"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1506_8850"
          x1="9.12934"
          y1="-9.36905e-07"
          x2="55.009"
          y2="61.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
